export default __webpack_public_path__ + "static/media/claim-satelment-ratio-icon.9a82ba74.svg";